import React from 'react';

import styled from 'styled-components';

import UIIcon, { EIcon, EIconSize } from '@aquariuxfintech/aqx-trader-react-ui/icon';
import UIText from '@aquariuxfintech/aqx-trader-react-ui/text';

import { useAppTheme } from '@aqx-core/common/theme';

interface IPasswordCriteriaItemProps {
  isValid: boolean;
}

const PasswordCriteriaItem: FCC<IPasswordCriteriaItemProps> = ({ children, isValid }) => {
  const { theme } = useAppTheme();
  return (
    <StyledContainer $isValid={isValid}>
      {isValid ? (
        <UIIcon size={EIconSize.M} color={theme.themeColors.pnl.positive.default} icon={EIcon.CHECK} />
      ) : (
        <UIIcon size={EIconSize.M} color={theme.themeColors.text.placeholder} icon={EIcon.SUBTRACT} />
      )}

      <StyledUIText $isValid={isValid}>{children}</StyledUIText>
    </StyledContainer>
  );
};

export default PasswordCriteriaItem;
const StyledContainer = styled.div<{ $isValid: boolean }>`
  display: flex;
  gap: 8px;
`;

const StyledUIText = styled(UIText)<{ $isValid: boolean }>`
  color: ${({ theme, $isValid }) =>
    $isValid ? theme.themeColors.pnl.positive.default : theme.themeColors.text.placeholder};
`;
